import { render, staticRenderFns } from "./paymentRequestForm.vue?vue&type=template&id=2a5bceec&"
import script from "./paymentRequestForm.vue?vue&type=script&lang=js&"
export * from "./paymentRequestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports